import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "menuProfile", "textShrink", "text"];

  connect() {
    this.boundSyncLayoutOffsets = this.syncLayoutOffsets.bind(this);
    window.addEventListener("resize", this.boundSyncLayoutOffsets);
    this.syncLayoutOffsets();

    if (this.hasSidebarTarget) {
      this.setSidebarState();
    }
  }

  disconnect() {
    if (this.boundSyncLayoutOffsets) {
      window.removeEventListener("resize", this.boundSyncLayoutOffsets);
    }
  }

  toggleSidebar() {
    this.sidebarTarget.classList.toggle("sidebar--shrink");

    const sidebarState = this.sidebarTarget.classList.contains("sidebar--shrink") ? "shrink" : "expand";
    localStorage.setItem("sidebarState", sidebarState);
    if (sidebarState === "shrink") {
      this.textTarget.classList.add("hidden");
      this.textShrinkTarget.classList.remove("hidden");
    } else {
      this.textTarget.classList.remove("hidden");
      this.textShrinkTarget.classList.add("hidden");
    }
  }

  setSidebarState() {
    const sidebarState = localStorage.getItem("sidebarState");

    if (sidebarState === "shrink") {
      this.sidebarTarget.classList.add("sidebar--shrink");
      this.textTarget.classList.add("hidden");
      this.textShrinkTarget.classList.remove("hidden");
    } else {
      this.sidebarTarget.classList.remove("sidebar--shrink");
      this.textTarget.classList.remove("hidden");
      this.textShrinkTarget.classList.add("hidden");
    }
  }

  toggleProfile() {
    this.menuProfileTarget.classList.toggle("hidden");
  }

  syncLayoutOffsets() {
    const root = document.documentElement;
    const footer = document.querySelector(".footer");
    const navbar = document.querySelector(".navbar");

    if (navbar) {
      const navbarHeight = Math.ceil(navbar.getBoundingClientRect().height);
      root.style.setProperty("--navbar-height", `${navbarHeight}px`);
    }

    if (footer) {
      const footerHeight = Math.ceil(footer.getBoundingClientRect().height);
      root.style.setProperty("--footer-height", `${footerHeight}px`);
    }
  }
}
